import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { Button } from './ui/button';

const Footer = ({ onOpenContactForm }) => {
  const currentYear = new Date().getFullYear();
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <footer data-testid="main-footer" className="relative overflow-hidden bg-[#041B1C] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-20 pb-10 relative z-10">

        <div className="grid lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-5">
            <span className="text-4xl font-bold tracking-tight text-[#F0F4F4] block mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>
              <img src="/logo.png" alt="Trademarking Company Name" className="h-12" />
            </span>
            <p className="text-sm text-[#A0B2B2] leading-relaxed mb-6 max-w-sm">
              Expert brand name trademark registration and federal protection. Licensed attorneys helping businesses secure their brand names across all 50 states.
            </p>
            <Button data-testid="footer-cta" onClick={onOpenContactForm}
              className="bg-[#A5BF23] hover:bg-[#8A9F1D] text-[#041B1C] font-semibold px-6 h-10 text-sm rounded-full transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_8px_32px_rgba(165,191,35,0.3)]">
              Free Consultation
            </Button>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-[#A5BF23] mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {[
                { id: 'why-register', label: 'Why Register' },
                { id: 'process', label: 'Our Process' },
                { id: 'pricing', label: 'Pricing' },
                { id: 'testimonials', label: 'Reviews' },
                { id: 'faq', label: 'FAQ' },
              ].map(link => (
                <li key={link.id}>
                  <button data-testid={`footer-link-${link.id}`} onClick={() => scrollTo(link.id)}
                    className="text-sm text-[#A0B2B2] hover:text-[#A5BF23] transition-colors">
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-[#A5BF23] mb-6">Get in Touch</h4>
            <ul className="space-y-4">
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-[#A5BF23] flex-shrink-0" strokeWidth={1.5} />
                <a href="tel:+18001234567" className="text-sm text-[#A0B2B2] hover:text-[#F0F4F4] transition-colors">+1 (800) 123-4567</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-[#A5BF23] flex-shrink-0" strokeWidth={1.5} />
                <a href="mailto:info@trademarkingcompanyname.com" className="text-sm text-[#A0B2B2] hover:text-[#F0F4F4] transition-colors break-all">info@trademarkingcompanyname.com</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[#A5BF23] flex-shrink-0 mt-0.5" strokeWidth={1.5} />
                <span className="text-sm text-[#A0B2B2]">11040 Santa Monica Blvd #310,<br />Los Angeles, CA 90025</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-[#A0B2B2]">&copy; {currentYear} Trademarking Company Name. All rights reserved.</p>
          <div className="flex gap-6 text-xs">
            <Link to="/privacy-policy" data-testid="footer-privacy-link" className="text-[#A0B2B2] hover:text-[#A5BF23] transition-colors">Privacy Policy</Link>
            <Link to="/terms-conditions" data-testid="footer-terms-link" className="text-[#A0B2B2] hover:text-[#A5BF23] transition-colors">Terms & Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
